import { AnimatedList } from "@/components/ui/animated-list";

const waProcesses = [{ name: "Inbound" }, { name: "Picking" }, { name: "Packing" }, { name: "Shipping" }];

export default function WATesterBentoItem() {
  return (
    <AnimatedList className="absolute inset-0 flex items-center justify-center h-[300px] w-full scale-75 border-none [mask-image:linear-gradient(to_top,transparent_10%,#000_100%)] transition-all duration-300 ease-out group-hover:scale-90">
      {waProcesses.map((process, idx) => (
        <p key={idx} className="text-xl text-center">
          {process.name}
        </p>
      ))}
    </AnimatedList>
  );
}
